import RpcService        from '@/core/services/Rpc/RpcService';
import type RpcResponse  from '@/core/services/Rpc/RpcResponse';
import type Unit         from '@/domains/Units/Unit';
import type RpcDataPagination from '@/core/services/Rpc/RpcDataPagination';
import type RpcDataSort       from '@/core/services/Rpc/RpcDataSort';


class UnitsDAO {

    static async get(id: number): Promise<RpcResponse> {
        return await RpcService.makeRequest('units.get', { id });
    }

    static async getList(
        filters?: {
            id?:        number;
            pattern?:   string;
            code?:      number;
            name?:      string;
            nameFull?:  string;
            isDeleted?: boolean;
        },
        pagination?: RpcDataPagination,
        sort?:       RpcDataSort,
    ): Promise<RpcResponse> {
        return await RpcService.makeRequest('units.getList', filters, pagination, sort);
    }

    static async add(unit: Unit): Promise<RpcResponse> {
        return await RpcService.makeRequest('units.add', { unit });
    }

    static async update(unit: Unit): Promise<RpcResponse> {
        return await RpcService.makeRequest('units.update', { unit });
    }

    static async delete(id: number): Promise<RpcResponse> {
        return await RpcService.makeRequest('units.delete', { id });
    }
}

export default UnitsDAO;